import type { Column } from "@tanstack/react-table";
import { Button } from "@/components/ui/button";
import {
  ArrowUpDown,
  ArrowUp,
  ArrowDown,
} from "lucide-react";

// SortableHeader component (sorting only, no filters)
export function SortableHeader<T>({ 
  column, 
  label,
}: { 
  column: Column<T, unknown>; 
  label: string;
}) {
  return (
    <Button
      variant="ghost"
      size="sm"
      className="h-8 -ml-2 -mr-2 hover:bg-transparent w-full flex items-center justify-start px-1"
      onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
    >
      <span className="truncate flex-1 min-w-0">{label}</span>
      <span className="flex-shrink-0 ml-1">
        {column.getIsSorted() === "asc" ? (
          <ArrowUp className="h-4 w-4" />
        ) : column.getIsSorted() === "desc" ? (
          <ArrowDown className="h-4 w-4" />
        ) : (
          <ArrowUpDown className="h-4 w-4 opacity-50" />
        )}
      </span>
    </Button>
  );
}

// Helper function to create sortable column header
export function createSortableHeader<T>(label: string) {
  return ({ column }: { column: Column<T, unknown> }) => (
    <SortableHeader column={column} label={label} />
  );
}

